export const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'https://api.swgrealms.com',
  playUrl: import.meta.env.VITE_PLAY_URL || 'https://play.swgrealms.com',
  homeUrl: import.meta.env.VITE_HOME_URL || 'https://www.swgrealms.com',
  partnerUrls: {
    swgemu: {
      signupUrl: 'https://www.swgemu.com/registration/swgrealms/',
      displayName: 'SWGEmu'
    }
  }
}
